import React, { useEffect, useState } from 'react';
import LcTooltip from '../../Generic/LcTooltip';
import ContentEditable from 'react-contenteditable';
import "./index.css";

interface Props {
    label?: string,
    height?: string | number
    width?: string | number
    placeholder?: string
    handleChange: Function
    error?: any,
    help?: any,
    disabled?: boolean,
    required?: boolean,
    handleFiles?: Function,
    value?: string
    id?: string
}

const HHDescriptionTextBox: React.FC<Props> = (props) => {
    const [text, setText] = useState<string>(props.value || '');
    const [focused, setFocused] = useState<boolean>(false);

    useEffect(() => {
        if (props.value) {
            setText(props.value);
        }
        else {
            props.placeholder && setText(props.placeholder);
        }
    }, [props.value])

    const getBorder = () => {
        if (props.error && !props.error.valid) {
            return "";
        }
        else if (props.disabled && props.disabled === true) {
            return "";
        }
        else if (props.required && props.required === true) {
            return "3px solid #FFB800";
        }
    }

    const pasteImage = async (event) => {
        if (props.handleFiles) {
            if (event.type === 'paste') {
                let itemFile = (event.originalEvent || event).clipboardData.getData("text/html");
                let textFile = (event.originalEvent || event).clipboardData.getData("text/plain");
                let item = event.clipboardData?.items[0] || event.clipboardData?.files[0];
                const parser = new DOMParser();
                const doc = parser.parseFromString(itemFile, "text/html");
                var image = doc.querySelector("img");

                if (image) {
                    const respose = await fetch(image.src);
                    const blob = await respose.blob();
                    let fileBlob = new File([blob], 'Anexo.jpeg', { type: blob.type })
                    var reader = new FileReader();

                    fileBlob && reader.readAsDataURL(fileBlob);
                    props.handleChange(textFile);
                    props.handleFiles([fileBlob]);
                }
                else if (item && item.type.indexOf("image") === 0) {
                    let blob = item.getAsFile();
                    var reader = new FileReader();

                    blob && reader.readAsDataURL(blob);
                    props.handleFiles([blob]);
                }
            }
            else {
                let item = event.dataTransfer?.items[0] || event.dataTransfer?.files[0];
                let blob = item.getAsFile();
                var reader = new FileReader();

                blob && reader.readAsDataURL(blob);
                props.handleFiles([blob]);
            }
        }
    }

    const handleChange = (e) => {
        if (!props.disabled) {
            const inputType = e.nativeEvent.inputType;

            let texto = e.target.value;

            // if (inputType === "insertFromPaste") {
            //     texto = texto.replace(/<[^>]*>/g, '')
            // }

            if ((inputType === "insertFromPaste") && e.target.value.includes("<img ")) {
                return;
            }

            setText(texto);
            props.handleChange(texto);
        }
    };

    const handleKeyPress = (e) => {
        if (props.disabled) {
            e.preventDefault();
        }
    };

    const handleFocus = () => {
        if (!props.disabled) {
            if (text === (props.placeholder || '')) {
                setText('');
            }

            setFocused(true);
        }
    };

    const handleBlur = () => {
        setFocused(false);
    };

    const disabledPasteImage = async (event) => {
        const items = (event.clipboardData || event.originalEvent.clipboardData).items;

        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
                event.preventDefault();
                return;
            }
        }
    }

    return (
        <>
            {
                props.label &&
                <div className={"input-4 label2"}> {props.label} </div>
            }
            <LcTooltip
                content={props.error ? props.help : ''}
                position={"left"}
                trigger={(props.error && !props.error.valid) ? "hover" : "none"}
                width={'100%'}
                maxWidth={'100%'}
            >
                <div className={`${(props.disabled) ? "divOrderRichTextBoxDecriptionNew_Disabled" : "divOrderRichTextBoxDecriptionNew"}`}>
                    <div
                        className={`textBoxEditorDecriptionNew ${props.error && !props.error.valid ? " classErrorDecriptionNew" : ""}`}
                        style={{
                            borderLeft: getBorder(),
                            backgroundColor: (props.disabled && props.disabled === true) ? "#EBEBEB" : "white",
                            color: (props.disabled && props.disabled === true) ? "darkgray" : "black",
                        }}
                        onPaste={pasteImage}
                    >
                        <ContentEditable
                            html={text}
                            onChange={handleChange}
                            tagName={"div"}
                            className={"editor-content"}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            onPaste={disabledPasteImage}
                            contentEditable={!focused || !props.disabled}
                            onKeyDown={handleKeyPress}
                            style={{
                                height: (props.height) ? props.height : '100%',
                                padding: '10px',
                                color: (text === props.placeholder || props.disabled) ? '#bababa' : 'black',
                            }}
                            spellCheck={false}
                            disabled={props.disabled}
                            id={props.id}
                        />
                    </div>
                </div>
            </LcTooltip>
        </>
    );
};

export default HHDescriptionTextBox;